import { EllipsedText, FlexRow, MaterialIcon, useModal } from '@gorila-shared-ui/components';
import Button from 'baseui/button/button';
import { LabelSmall, ParagraphSmall } from 'baseui/typography';
import { memo } from 'react';
import { useSetRecoilState } from 'recoil';
import { useCamera } from '../../hooks/useCamera';
import { useStyles } from '../../hooks/useStyles';
import { usersPageState } from '../../storage/userStates';
import { User } from '../../types/users';
import { isValidPosition } from '../../utils/map';
import StyledTooltip from '../ui/StyledTooltip';
import { UserModal } from './UserModal';

type Props = {
  user: User;
};
function UserCardHeader({ user }: Readonly<Props>) {
  const { theme, css } = useStyles();
  const setUsersPage = useSetRecoilState(usersPageState);
  const { openModal, closeModal, showModal } = useModal();
  const { zoomTo } = useCamera();

  const onUpdate = () => {
    setUsersPage(0);
  };

  const onSubmitFinished = () => {
    closeModal();
    onUpdate();
  };

  const isValidPoint = isValidPosition(user.lastPosition?.latitude, user.lastPosition?.longitude);

  const lng = user.lastPosition?.longitude ?? 0;
  const lat = user.lastPosition?.latitude ?? 0;

  return (
    <FlexRow
      classNames={css({
        padding: `${theme.sizing.scale200} ${theme.sizing.scale400}`,
        alignItems: 'center',
        justifyContent: 'space-between',
      })}
    >
      <StyledTooltip content="Nombre del usuario">
        <LabelSmall margin={'2px 0 0'}>
          <EllipsedText
            breakAll
            inline
          >
            {`${user.firstName} ${user.lastName}`}
          </EllipsedText>
        </LabelSmall>
      </StyledTooltip>
      <FlexRow
        gap={0}
        classNames={css({ alignItems: 'center' })}
      >
        <StyledTooltip content="Estatus">
          <ParagraphSmall
            margin={0}
            color={user.active ? theme.colors.positive : theme.colors.negative}
          >
            {user.active ? 'Activo' : 'Inactivo'}
          </ParagraphSmall>
        </StyledTooltip>
        <StyledTooltip
          content={'Editar'}
          showArrow={false}
        >
          <Button
            size="mini"
            shape="square"
            onClick={openModal}
            kind="tertiary"
          >
            <MaterialIcon
              name={'edit'}
              size="xs-mini"
            />
          </Button>
        </StyledTooltip>
        {isValidPoint && (
          <StyledTooltip
            content={'Encontrar en el mapa'}
            showArrow={false}
          >
            <Button
              size="mini"
              shape="square"
              onClick={() => zoomTo({ lat, lng })}
              kind="tertiary"
            >
              <MaterialIcon
                name={'location_searching'}
                size="xs-mini"
              />
            </Button>
          </StyledTooltip>
        )}
      </FlexRow>
      <UserModal
        isOpen={showModal}
        onClose={closeModal}
        onSubmitFinished={onSubmitFinished}
        user={user}
        userId={user._id}
      />
    </FlexRow>
  );
}

export default memo(UserCardHeader);
